var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15312 11.6364C9.38125 10.9606 9.8375 10.3485 10.3531 9.82121C11.375 8.77879 12 7.3697 12 5.81818C12 2.60606 9.3125 0 6 0C2.6875 0 0 2.60606 0 5.81818C0 7.3697 0.625 8.77879 1.64687 9.82121C2.1625 10.3485 2.62188 10.9606 2.84688 11.6364H9.15H9.15312ZM9 13.0909H3V13.5758C3 14.9152 4.11875 16 5.5 16H6.5C7.88125 16 9 14.9152 9 13.5758V13.0909ZM5.75 3.39394C4.50625 3.39394 3.5 4.3697 3.5 5.57576C3.5 5.97879 3.16563 6.30303 2.75 6.30303C2.33437 6.30303 2 5.97879 2 5.57576C2 3.56667 3.67812 1.93939 5.75 1.93939C6.16563 1.93939 6.5 2.26364 6.5 2.66667C6.5 3.0697 6.16563 3.39394 5.75 3.39394Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.0122f831b94db0c0b5bbe0a4acde0fa1.svg";
export { ForwardRef as ReactComponent };